
    <div fieldmagicGridRow>
      <div fieldmagicGridColumn="12">
        <table class="table table-bordered">
          <thead>
            <tr>
              <td
                colspan="2"
                width="30%"
              >
                <fieldmagic-text
                  content="Defects"
                  purpose="table-header"
                >
                </fieldmagic-text>
              </td>
              <td
                width="50%"
              >
                <fieldmagic-text
                  content="Description"
                  purpose="table-header"
                >
                </fieldmagic-text>
              </td>
              <td
                width="20%"
              >
                <fieldmagic-text
                  content="Linked Product"
                  purpose="table-header"
                >
                </fieldmagic-text>
              </td>
            </tr>
          </thead>

          <tbody>
            <ng-container *ngIf="fetching$ | async">
              <tr class="text-center">
                <td colspan="4">
                  <fieldmagic-icon [spin]="true"></fieldmagic-icon>
                </td>
              </tr>
            </ng-container>

            <ng-container *ngIf="! (fetching$ | async)">
              <ng-container *ngIf="severities$ | async as severities">
                <tr
                  *ngIf="severities | blank"
                  class="text-center"
                >
                  <td colspan="4">{{ 'No possible defects available.' | translate }}</td>
                </tr>

                <ng-container *ngFor="let severity of severities; let index = index">
                  <tr
                    [style.background]="severity.color"
                    [style.color]="severity.color | bg_text_color"
                  >
                    <td
                      colspan="4"
                      style="padding: 6px;"
                    >
                      <div class="d-flex d-flex-gap align-items-center">
                        {{ severity.severity }}
                      </div>
                    </td>
                  </tr>

                  <tr *ngFor="let fault of severity.faults">
                    <td
                      width="2%"
                      style="border-right: 0; padding-right: 0;"
                    >
                      <div class="bg-indent"></div>
                    </td>
                    <td style="padding: 6px; border-left: 0; padding-left: 8px;">
                      {{ fault.fault }}
                    </td>
                    <td>
                      {{ fault.description | placeholdWithString }}
                    </td>
                    <td>
                      <fieldmagic-text-link
                        [segments]="['/items', fault.item_id]"
                        [label]="fault.item_text"
                        [openNewTab]="true"
                      >
                      </fieldmagic-text-link>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  